import { createFileRoute } from '@tanstack/react-router'

import { PropensityToPayScreen } from './-components/propensity-to-pay-screen.tsx'

export const Route = createFileRoute('/cs-tools/propensity-to-pay')({
  component: PropensityToPayScreen
})
